import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { LoginPage } from "./pages/LoginPage";
import { AdminDashboard } from "./pages/AdminDashboard";
import { UsersPage } from "./pages/UsersPage";
// import { ReviewsPage } from "./pages/ReviewsPage";
import { SettingsPage } from "./pages/SettingsPage";
import { AdminBilling } from "./pages/AdminBilling";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Редирект с корня на админку */}
          <Route path="/" element={<Navigate to="/admin" replace />} />

          {/* Страница авторизации */}
          <Route path="/admin/login" element={<LoginPage />} />

          {/* Защищенные страницы админки */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/users"
            element={
              <ProtectedRoute role="superadmin">
                <UsersPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/billing"
            element={
              <ProtectedRoute role="superadmin">
                <AdminBilling />
              </ProtectedRoute>
            }
          />

          {/* Reviews route removed */}

          <Route
            path="/admin/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            }
          />

          {/* Fallback - редирект на логин */}
          <Route path="*" element={<Navigate to="/admin/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
